import { ClusterFragment, ClusterSortField } from "@/core/graphql/graphql";
import { Column, ColumnType } from "@/shared/components/table/table.model";
import { extractProperty, extractBooleanProperty } from "@/utils/extract-property";

export const CLUSTER_COLUMNS: Column<ClusterFragment>[] = [
  {
    columnId: "id",
    caption: "ID",
    fieldSelector: (element: ClusterFragment) => extractProperty(element.id),
  },
  {
    columnId: "name",
    caption: "Name",
    sortable: true,
    fieldSelector: (element: ClusterFragment) => extractProperty(element.name),
  },
  {
    columnId: "owner",
    caption: "Owner",
    fieldSelector: (element: ClusterFragment) => extractProperty(element.owner.username),
  },
  {
    columnId: "updatedAt",
    caption: "Updated",
    fieldSelector: (element: ClusterFragment) => extractProperty(element.updatedAt),
    sortable: true,
    type: ColumnType.Date,
  },
  {
    columnId: "numberOfElements",
    caption: "#Elements",
    fieldSelector: (element: ClusterFragment) => extractProperty(element.numberOfElements),
  },
  {
    columnId: "followersCount",
    caption: "#Followers",
    fieldSelector: (element: ClusterFragment) => extractProperty(element.followersCount),
  },
  {
    columnId: "isPrivate",
    caption: "Private",
    fieldSelector: (element: ClusterFragment) => extractBooleanProperty(element.isPrivate),
  },
  {
    columnId: "isFeatured",
    caption: "Featured",
    fieldSelector: (element: ClusterFragment) => extractBooleanProperty(element.isFeatured),
  },
  {
    columnId: "coverImageUrl",
    caption: "Cover",
    fieldSelector: (element: ClusterFragment) => extractProperty(element.coverImageUrl),
    type: ColumnType.Image,
  },
];

export const CLUSTER_SORT_FIELD = (option: string): ClusterSortField => {
  switch (option) {
  case "updatedAt":
    return ClusterSortField.UpdatedAt;
  case "name":
    return ClusterSortField.Name;
  default:
    throw new Error('Unsupported sorting field');
  }
};
